<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Notifiche Pazienti</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a routerLink="/main">Home</a></li>
                    <li class="breadcrumb-item"><a routerLink="/main/pazienti">Pazienti</a></li>
                </ol>
            </div>
        </div>
    </div><!-- /.container-fluid -->
</section>
<div class="card">
    <div class="card-header border-0" *ngIf="false">
        <div class="p-fluid justify-content-between">
            <h3 class="card-title">Notifiche Pazienti</h3>
        </div>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-md-2">
                <div class="card">
                    <div class="card-body p-0">
                        <p-listbox [options]="listItem" [(ngModel)]="itemSelected" (onChange)="getTypeAlert($event)">
                            <ng-template let-elem pTemplate="item">
                                <i [class]="elem.icon"></i>
                                &nbsp; {{elem.label}} &nbsp; <span style="font-size:0.8em"
                                    *ngIf="elem.label=='Nuovi' && countAlerts && countAlerts!=0"
                                    class="badge badge-danger">{{countAlerts}}</span>
                            </ng-template>
                        </p-listbox>
                    </div>
                </div>
            </div>
            <div class="col-md-10">
                <p-table #dt [columns]="colonne" [value]="rows" [lazy]="true" (onLazyLoad)="setPage($event)"
                    [paginator]="true" [rows]="10" [totalRecords]="page.totalElements" [responsive]="true"
                    tableStyleClass="mailbox-messages" [(first)]="first">
                    <ng-template pTemplate="caption">
                        <form [formGroup]="formRicerca">
                            <div class="row form-group labelWithMarginLeft">
                                <div class="col-3">
                                    <label for="patientFilter">Identificativo paziente</label>
                                    <input type="text" pInputText size="50" formControlName="patientFilter"
                                        placeholder="Filtra per identificativo paziente" class="form-control">
                                </div>
                                <div class="col-2">
                                    <label for="typeFilter">Tipologia notifica</label>
                                    <p-dropdown [options]="typesOptions" dropdownIcon="fas fa-chevron-down"
                                        emptyMessage="Tipologia notifica" appendTo="body" formControlName="typeFilter"
                                        placeholder="Tipologia notifica"></p-dropdown>
                                </div>
                                <div class="col-3">
                                    <label for="periodo">Periodo di riferimento</label>
                                    <input class="mt-2" type="text" #daterangepicker="bsDaterangepicker"
                                        class="form-control" placeholder="Periodo di riferimento" bsDaterangepicker
                                        formControlName="periodo" [bsConfig]="datePickerConf" placement="left"
                                        style="width: fit-content; min-width: 70%;">
                                </div>
                                <div class="offset-2 col-2" style="text-align:right">
                                    <label style="visibility:hidden">Periodo di riferimento</label>
                                    <p-button class="mr-1" type="button" (click)="setAllRead()" label="Leggi tutti"
                                        *ngIf="this.registered" iconPos="left" icon="fa fa-check">
                                    </p-button>
                                </div>
                            </div>
                        </form>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th style="width:8em">
                                <div style="display: inline-block;">
                                    {{colonne[0].name}}
                                </div>
                            </th>
                            <th style="width:12em">
                                {{colonne[1].name}}
                            </th>
                            <th style="width:6em">
                                {{colonne[2].name}}
                            </th>
                            <th style="width:6em">
                                {{colonne[3].name}}
                            </th>
                            <th *ngIf="registered" style="width:6em">
                            </th>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pSelectableRow]="rowData">
                            <td *ngFor="let col of columns">
                                <span class="p-column-title">{{col.name}}</span>
                                {{rowData[col.prop]}}
                            </td>
                            <td style="text-align:center" *ngIf="registered">
                                <p-button type="button" (click)="setVerificato(rowData.id)" label="Segna come letto"
                                    iconPos="left" icon="fa fa-check">
                                </p-button>
                            </td>
                        </tr>

                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="columns.length + (registered ? 1 : 0)">
                                <label>Nessun alert trovato</label>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

        </div>
    </div>
</div>